import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { queryClient } from '@/lib/utils/queryClient';
import { OrdersHubPage } from '../-components/OrdersHubPage';
import { ordersHubQueryOptions } from '../-hooks/useOrdersHubList';
import { ORDERS_HUB_DEFAULT_SORT } from '../-utils/listParams';

const ordersHubSearch = z.object({
  tab: z.enum(['orders', 'orderLines']).optional().catch(undefined),
  page: z.number().int().min(1).catch(1),
  limit: z.number().int().min(10).max(100).catch(50),
  sort: z
    .string()
    .transform(v => (/^\w+:(ASC|DESC)$/.test(v) ? v : undefined))
    .optional(),
  filters: z
    .union([
      z.string().transform(v => {
        try {
          return JSON.parse(v) as Record<string, string[]>;
        } catch {
          return undefined;
        }
      }),
      z.record(z.array(z.string())),
    ])
    .optional(),
});

export const Route = createFileRoute('/(client)/orders-hub/(pages)/')({
  validateSearch: ordersHubSearch,
  loader: () =>
    queryClient.ensureQueryData(
      ordersHubQueryOptions({
        page: 1,
        count: 50,
        sort: ORDERS_HUB_DEFAULT_SORT,
      }),
    ),
  component: OrdersHubPage,
});
